import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import EndocrineProgesteroneCombined from "./index";

const EndocrineProgesteroneWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={EndocrineProgesteroneCombined}
    keyControlsId="endocrine-progesterone-key"
    {...props}
  />
);

export default EndocrineProgesteroneWithToggleKey;
